export enum LinkType {
    Internal,
    External,
    SCOUT,
    MULTI
};

export enum LinkSvgType {
  Locked,
  Unlocked,
  Description,
};
